var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8572 12.1332L11.9285 10.9271L10.5684 11.6108L10.255 10.1212L8.73297 10.1471L9.09689 8.66897L7.71436 8.03192L8.68357 6.85811L7.71436 5.6843L9.09689 5.04725L8.73297 3.56915L10.255 3.59503L10.5684 2.10541L11.9285 2.78911L12.8572 1.58301L14.5657 6.85811L12.8572 12.1332Z",
    fill: "#FFB655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0307 6.85819L18 5.68438L16.6174 5.04733L16.9814 3.56923L15.4593 3.59511L15.1459 2.10549L13.7858 2.78919L12.8571 1.58309V12.1333L13.7858 10.9272L15.1459 11.6109L15.4593 10.1213L16.9814 10.1472L16.6174 8.66905L18 8.032L17.0307 6.85819Z",
    fill: "#FFB655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1142 6.85719L12.8572 9.64694C11.3165 9.64694 10.0675 8.39791 10.0675 6.85719C10.0675 5.31647 11.3165 4.06745 12.8572 4.06745L14.1142 6.85719Z",
    fill: "#FFE89C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 4.06745C14.3979 4.06745 15.6469 5.31647 15.6469 6.85719C15.6469 8.39791 14.3979 9.64694 12.8571 9.64694V4.06745Z",
    fill: "#FFE89C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00003 15.4068C1.87871 15.3057 1 14.3634 1 13.2157C1 12.0007 1.98497 11.0158 3.19999 11.0158C3.26915 11.0158 3.33755 11.0189 3.40508 11.0252C3.40167 10.9558 3.39994 10.8859 3.39994 10.8156C3.39994 8.49604 5.28034 6.61565 7.59992 6.61565C9.5915 6.61565 11.2593 8.00183 11.6912 9.86202C11.8562 9.83172 12.0262 9.81589 12.2 9.81589C13.7464 9.81589 15 11.0695 15 12.6159C15 14.1623 13.7464 15.4159 12.2 15.4159C12.1989 15.4159 12.1978 15.4159 12.1967 15.4159H3.00003V15.4068Z",
    fill: "#C4E1E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09149 7.44625C5.25826 7.42612 5.42804 7.41575 5.60024 7.41575C7.59179 7.41575 9.25959 8.80191 9.69148 10.6621C9.85638 10.6318 10.0263 10.616 10.2 10.616C11.7464 10.616 13 11.8696 13 13.416C13 14.1992 12.6784 14.9073 12.1601 15.4155H12.1967L12.2 15.4155C13.7464 15.4155 15 14.1619 15 12.6155C15 11.0691 13.7464 9.81548 12.2 9.81548C12.0262 9.81548 11.8562 9.83131 11.6911 9.8616C11.2593 8.00142 9.59147 6.61523 7.59989 6.61523C6.65958 6.61523 5.79144 6.92424 5.09149 7.44625Z",
    fill: "#A4D5DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/morning.51f8c47179b71d90b4cca716c2976371.svg";
export { ForwardRef as ReactComponent };